module.exports = __webpack_public_path__ + "static/media/udemy_logo.053ca7fc.png";